export class IntendedTarget {
  intendedTargetId: string;
  intendedTargetName: string;
}
